export { MailAlt as default } from './MailAlt';
